import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import Logo from "@/components/Logo";
import { phoneHref } from "@/lib/data";

const NAV_LINKS = [
  ["Services", "#services"],
  ["Before & After", "#gallery"],
  ["Why Choose Us", "#why-us"],
  ["Areas Covered", "#areas"],
  ["Reviews", "#reviews"],
  ["FAQ", "#faq"],
];

export default function Navbar({ content }) {
  const phone = content?.phone || "07378114330";
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-[#070b12]/90 sticky top-0 z-40 border-b border-[#1e9bff]/20 backdrop-blur-md" data-testid="navbar">
      <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" aria-label="SY Exterior Cleaning home" onClick={() => setOpen(false)}>
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-xs font-mono-lbl uppercase tracking-[0.14em] text-[#93b4d4]">
          {NAV_LINKS.map(([label, href]) => (
            <a key={href} href={href} data-testid={`nav-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="hover:text-white transition-colors">
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="/#booking"
            data-testid="nav-book-now-btn"
            className="hidden sm:inline-flex items-center justify-center px-4 py-2.5 rounded-full bg-[#1e9bff] text-black text-xs font-bold uppercase tracking-wider hover:bg-[#60baff] transition-colors sy-glow-btn"
          >
            Book Now
          </a>
          <a
            href={phoneHref(phone)}
            data-testid="nav-call-btn"
            aria-label={`Call ${phone}`}
            className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-full border border-[#1e9bff]/40 text-[#1e9bff] text-xs font-mono-lbl hover:bg-[#1e9bff]/10 transition-colors"
          >
            <span className="w-2 h-2 rounded-full bg-[#1e9bff] animate-ping"></span>
            {phone}
          </a>
          <a
            href={phoneHref(phone)}
            data-testid="nav-call-icon-btn"
            aria-label={`Call ${phone}`}
            className="sm:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#1e9bff]/40 text-[#1e9bff] hover:bg-[#1e9bff]/10 transition-colors"
          >
            <Phone className="w-4 h-4" />
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-menu-btn"
            aria-label={open ? "Close menu" : "Open menu"}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-white hover:border-[#1e9bff]/50 transition-colors"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-[#1e9bff]/20 bg-[#070b12] px-4 py-3 space-y-1" data-testid="mobile-menu">
          {NAV_LINKS.map(([label, href]) => (
            <a
              key={href}
              href={href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="block px-3 py-3 rounded-xl text-sm font-mono-lbl uppercase tracking-[0.14em] text-[#93b4d4] hover:text-white hover:bg-white/5 transition-colors"
            >
              {label}
            </a>
          ))}
          <a
            href="/#booking"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-book-btn"
            className="block mt-2 px-3 py-3.5 rounded-xl bg-[#1e9bff] text-black text-sm font-bold uppercase tracking-wider text-center"
          >
            Book Now
          </a>
        </nav>
      )}
    </header>
  );
}
